import React from 'react';
import { useSelector } from 'react-redux';
import Orders from 'src/pages/orders';

/**
 * Date range used for the Order History view.
 * These values are sent on every Order History list payload
 * (start/end date) so the saga does not hardcode them.
 */
export const ORDER_HISTORY_START_DATE = '2021-02-04T18:30:00Z';
export const ORDER_HISTORY_END_DATE = '2026-04-30T18:00:00Z';
const OrderHistory = () => {
    return <Orders isOrderHistory={true} />;
};

export default OrderHistory;
